import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  // 商品详情
  goodsParticulars: (data) => apiAxios('post', baseURL + '/client/goodsParticulars', data),
  // 订单- 查询单客户单番商品标准手续费比例
  getServiceRate: (data) => apiAxios('post', baseURL + '/order.getServiceRate', data),
    // 再下一单预览
  copyOrder: (data) => apiAxios('post', baseURL + '/order.copyOrder', data),
  //订单-MAP-整个订单所有状态
  orderStatusMap: (data) => apiAxios('post', baseURL + '/order.orderStatusMap', data),
  //订单列表基准地址
  orderList: (data) => apiAxios('post', baseURL + '/order.list', data),
  //所有订单类型
  typeList: (data) => apiAxios('post', baseURL + '/order.typeList', data),
  //商品附加服务列表
  orderOptionList: (data) => apiAxios('post', baseURL + '/order.optionList', data),
  //单番商品所有状态MAP
  orderDetailStatusMap: (data) => apiAxios('post', baseURL + '/order.orderDetailStatusMap', data),
  //订单-修改备注
  updateRemark: (data) => apiAxios('post', baseURL + '/order.updateRemark', data),
  // 订单明细-修改下单方案要求备注，order_detail_id 支持数组。
  updatePlanRemark: (data, config = {}) => apiAxios('post', baseURL + '/order.updatePlanRemark', data, config),
  //订单-修改订单属性
  updateAttribute: (data) => apiAxios('post', baseURL + '/order.updateAttribute', data),
  //订单-修改订单类型
  updateType: (data) => apiAxios('post', baseURL + '/order.updateType', data),
  //订单详情
  orderDetails: (data) => apiAxios('post', baseURL + '/order.detail', data),
  // 订单详情-新增或更新标签
  updateTag: (data) => apiAxios('post', baseURL + '/order.tag.updateTag', data),
  modifyTag: (data) => apiAxios('post', baseURL + '/order.tag.modifyTag', data),
  // 订单详情-标记标签已打印（优先使用标签主键）
  printTag: (data) => apiAxios('post', baseURL + '/order.tag.print', data),
  // 订单详情-登记已打印标签的补打原因和申请数量
  printReasonStore: (data) => apiAxios('post', baseURL + '/order.tag.printReasonStore', data),
  // 订单标签-扫码历史列表
  tagScanList: (data) => apiAxios('post', baseURL + '/order.tag.scanList', data),
  // 订单标签-扫码校验
  tagScan: (data) => apiAxios('post', baseURL + '/order.tag.scan', data),
  // 订单详情-删除标签（order_detail_tag_id 支持数组或单个 ID）
  deleteTag: (data) => apiAxios('post', baseURL + '/order.tag.deleteTag', data),
  // 订单详情-批量追加或替换标签第 3、4 行文本
  batchAppendTagText: (data) => apiAxios('post', baseURL + '/order.tag.batchAppendTagText', data),
  // 订单详情-清空标签匹配和打印数据
  deleteMatchData: (data) => apiAxios('post', baseURL + '/order.tag.deleteMatchData', data),
  // 订单详情-批量修改标签条码格式和仓库类型
  batchModifyCodeType: (data) => apiAxios('post', baseURL + '/order.tag.batchModifyCodeType', data),
  // 订单详情-商品码覆盖标签第 1 行文本
  batchGoodsNoCoverTextOne: (data) => apiAxios('post', baseURL + '/order.tag.batchGoodsNoCoverTextOne', data),
  // 订单详情-标签匹配上传
  textMatch: (data) => apiAxios('post', baseURL + '/order.tag.textMatch', data),
  //批量调整人员
  adjustOrderAdmin: (data) => apiAxios('post', baseURL + '/order.adjustOrderAdmin', data),
  //批量调整人员
  adjustOrderP: (data) => apiAxios('post', baseURL + '/order.adjustOrderP', data),
  // 删除订单
  deleteOrder: (data) => apiAxios('post', baseURL + '/order.deleteOrder', data),
  // 订单-未到货订单列表
  getOrderNoArriveGoodsList: (data) => apiAxios('post', baseURL + '/order.getOrderNoArriveGoodsList', data),
  // 订单-待跟进物流列表
  getOrderFollowExpressList: (data) => apiAxios('post', baseURL + '/order.getOrderFollowExpressList', data),
  // 订单-物流号--单个物流号实际物流状态
  expressStatusReal: (data) => apiAxios('post', baseURL + '/order.expressStatusReal', data),
  // 订单-删除商品-(仅待翻译状态)
  deleteFromOrder: (data) => apiAxios('post', baseURL + '/order.deleteFromOrder', data),


  // 手动更新订单状态
  updateStatus: (data) => apiAxios('post', baseURL + '/order.updateStatus', data),
  // 业务翻译提交
  submitTranslate: (data) => apiAxios('post', baseURL + '/order.submitTranslate', data),
  // 订单-回退到待翻译
  backToWaitTranslate: (data) => apiAxios('post', baseURL + '/order.backToWaitTranslate', data),
  //采购调查提交
  submitConfirm: (data) => apiAxios('post', baseURL + '/order.submitConfirm', data),
  // 采购商品询盘-批量创建
  purchaseGoodsInquiryBatchCreate: (data) => apiAxios('post', baseURL + '/purchaseGoodsInquiry.batchCreate', data),
  // 采购商品询盘-单番记录弹窗
  purchaseGoodsInquiryPopup: (data) => apiAxios('post', baseURL + '/purchaseGoodsInquiry.popup', data),
  //业务报价提交
  submitOffer: (data) => apiAxios('post', baseURL + '/order.submitOffer', data),
  //回退到待报价
  backToWaitOffer: (data) => apiAxios('post', baseURL + '/order.backToWaitOffer', data),
  //回退到待调查
  backToWaitConfirm: (data) => apiAxios('post', baseURL + '/order.backToWaitConfirm', data),
  //订单-订单/配送单附件-添加
  storeOrderFile: (data) => apiAxios('post', baseURL + '/order.storeOrderFile', data),
  //订单-订单/配送单附件-删除
  deleteOrderFile: (data) => apiAxios('post', baseURL + '/order.deleteOrderFile', data),
  //订单-校验黑名单店铺订单号
  blackShopOrder: (data) => apiAxios('post', baseURL + '/order.blackShopOrder', data),
  //订单-增加新的跟单备注PLUS
  addOrderDetailNotes: (data) => apiAxios('post', baseURL + '/order.addOrderDetailNotes', data),
  //订单-新的跟单备注标记已读
  markNotesReadedAt: (data) => apiAxios('post', baseURL + '/order.markNotesReadedAt', data),
  //订单-新的跟单备注-列表
  orderDetailNoticeList: (data) => apiAxios('post', baseURL + '/order.orderDetailNoticeList', data),
  //转寄订单-标记订单手否收商品金额及手续费收取规则
  updateOrderPayRule: (data) => apiAxios('post', baseURL + '/order.updateOrderPayRule', data),
  //转寄订单-客户按等级的手续费比例
  userLevelRate: (data) => apiAxios('post', baseURL + '/order.userLevelRate', data),


  //采购设置换购信息
  storeReplaceGoods: (data) => apiAxios('post', baseURL + '/order.storeReplaceGoods', data),
  //业务修改换购信息
  updateReplaceGoods: (data) => apiAxios('post', baseURL + '/order.updateReplaceGoods', data),
  //业务创建订单
  manageCreateOrder: (data) => apiAxios('post', baseURL + '/order.manageCreateOrder', data),
  //回退待入金
  backToWaitPay: (data) => apiAxios('post', baseURL + '/order.backToWaitPay', data),
  //直接付款
  adminOrderPay: (data) => apiAxios('post', baseURL + '/order.adminOrderPay', data),


  /* 采购*/
  //待采购列表
  purchaseList: (data) => apiAxios('post', baseURL + '/purchase.purchaseList', data),
  //临时表单数据保存
  saveTemp: (data) => apiAxios('post', baseURL + '/purchase.saveTemp', data),
  //采购-生成1688订单价格预览
  orderCreatePreview: (data) => apiAxios('post', baseURL + '/purchase.orderCreatePreview', data),
  //到待改价
  toWaitModifyPrice: (data) => apiAxios('post', baseURL + '/purchase.toWaitModifyPrice', data),
  //到待财务付款
  toWaitPay: (data) => apiAxios('post', baseURL + '/purchase.toWaitPay', data),
  //生成1688订单
  alibabaOrderCreate: (data) => apiAxios('post', baseURL + '/purchase.alibabaOrderCreate', data),
  //生成taobao订单
  taobaoOrderCreate: (data) => apiAxios('post', baseURL + '/purchase.taobaoOrderCreate', data),
  //采购-生成网易(163)订单
  neteaseOrderCreate: (data) => apiAxios('post', baseURL + '/purchase.neteaseOrderCreate', data),
  //淘宝人工手动下单
  taobaoOrderCreateHuman: (data) => apiAxios('post', baseURL + '/purchase.taobaoOrderCreateHuman', data),
  //1688人工手动下单
  alibabaOrderCreateHuman: (data) => apiAxios('post', baseURL + '/purchase.alibabaOrderCreateHuman', data),
  //供应商人工手动下单
  supplierOrderCreate: (data) => apiAxios('post', baseURL + '/purchase.supplierOrderCreate', data),
  //修改购买备注(给财务看的)
  updatePurchaseRemark: (data) => apiAxios('post', baseURL + '/purchase.updatePurchaseRemark', data),
  // 采购询盘消息-获取消息模版列表
  purchaseMessageList: (data) => apiAxios('post', baseURL + '/purchaseMessage.list', data),
  // 采购询盘消息-设置消息模版
  purchaseMessageSet: (data) => apiAxios('post', baseURL + '/purchaseMessage.set', data),

  /* 客户已付款的*/
  //-禁止自动回调物流号-设置
  forbidCallbackExpress: (data) => apiAxios('post', baseURL + '/order.forbidCallbackExpress', data),
  //客户付款后订单详情--添加物流号
  addExpress: (data) => apiAxios('post', baseURL + '/purchase.addExpress', data),
  // 客户付款后订单详情--删除物流号
  deleteExpress: (data) => apiAxios('post', baseURL + '/purchase.deleteExpress', data),
  // 客户付款后订单详情--修改物流号
  updateExpress: (data) => apiAxios('post', baseURL + '/purchase.updateExpress', data),
  // 客户付款后订单详情--交易号拆分
  splitPurchaseNo: (data) => apiAxios('post', baseURL + '/purchase.splitPurchaseNo', data),
  // 客户付款后订单详情--交易号修改
  updatePurchase: (data) => apiAxios('post', baseURL + '/purchase.updatePurchase', data),
  // 订单-品名材质-表单预览
  orderMaterialPreview: (data) => apiAxios('post', baseURL + '/order.orderMaterialPreview', data),
  // 订单-品名材质-保存
  setOrderMaterial: (data) => apiAxios('post', baseURL + '/order.setOrderMaterial', data),
  // 订单-修改客户提交商品规格
  updateOrderDetail: (data) => apiAxios('post', baseURL + '/order.updateOrderDetail', data),
  // 订单-修改跟进备注
  followRemarkEdit: (data) => apiAxios('post', baseURL + '/order.followRemarkEdit', data),
  // 修改订单详情商品图片
  updateOrderImage: (data) => apiAxios('post', baseURL + '/order.updateOrderImage', data),

  // 订单-报价前合单
  mergeOrder: (data) => apiAxios('post', baseURL + '/order.mergeOrder', data),
  // 订单-报价前拆单
  splitOrder: (data) => apiAxios('post', baseURL + '/order.splitOrder', data),
  // Excel下单-上传excel
  excelOrder: (data) => apiAxios('post', baseURL + '/order.excelOrder', data),
  // 订单-修改订单物流方式
  updateOrderLogistics: (data) => apiAxios('post', baseURL + '/order.updateOrderLogistics', data),
  //订单-修改订单单番备注
  updateGoodsRemark: (data) => apiAxios('post', baseURL + '/order.updateGoodsRemark', data),
  //订单->业务开始翻译(禁止客户提交)
  isYEditing: (data) => apiAxios('post', baseURL + '/order.isYEditing', data),
  //订单-订单单番时间节点
  getSortingTimeNode: (data) => apiAxios('post', baseURL + '/order.getSortingTimeNode', data),
  //订单-单独修改单番商品业务编辑属性
  updateSortingDetail: (data) => apiAxios('post', baseURL + '/order.updateSortingDetail', data),
  //订单-设定订单分批付款计划
  updateOrderPartPayPlan: (data) => apiAxios('post', baseURL + '/order.updateOrderPartPayPlan', data),
  //订单-查询商品历史长宽高重
  goodsWeightSizeHistory: (data) => apiAxios('post', baseURL + '/order.goodsWeightSizeHistory', data),


  // // 物流运费模拟计算接口
  // logisticsPriceTest: (data) => apiAxios('post', baseURL + '/order.logisticsPriceTest', data),
  // //业务翻译提交
  // submitTranslate: (data) => apiAxios('post', baseURL + '/order.submitTranslate', data),
  // //回退到待报价
  // backToOffer: (data) => apiAxios('post', baseURL + '/order.backToOffer', data),
  // //回退待入金
  // backToNotPay: (data) => apiAxios('post', baseURL + '/order.backToNotPay', data),
  // //后台获取商品详情
  // getProductDetail: (data) => apiAxios('post', baseURL + '/order.getProductDetail', data),
  // //采购-添加换购信息
  // storeReplaceGoodsMessage: (data) => apiAxios('post', baseURL + '/order.storeReplaceGoods', data),
  // //业务-修改换购的信息
  // updateGoodsReplaceLinkInfo: (data) => apiAxios('post', baseURL + '/order.updateReplaceInfo', data),
  // //修改商品属性提交
  // updateGoodsAttr: (data) => apiAxios('post', baseURL + '/order.updateGoodsAttr', data),
  // //订单删除
  // orderDelete: (data) => apiAxios('post', baseURL + '/order.delete', data),


  // //实时汇率
  // exchangeRate: (data) => apiAxios('post', baseURL2 + '/common/exchangeRate', data),
  // //获取订单内商品品名
  // getOrderMaterial: (data) => apiAxios('post', baseURL + '/order.getOrderMaterial', data),
  // //品名-可选分类
  // getMaterialClassify: (data) => apiAxios('post', baseURL + '/order.goodsTypes', data),
  // //品名-订单品名编辑
  // submitOrderMaterial: (data) => apiAxios('post', baseURL + '/order.setOrderMaterial', data),
  // //业务退给采购重新确认
  // backToBuyerConfirm: (data) => apiAxios('post', baseURL + '/order.backToConfirm', data),
  // //客户付款后订单详情--添加物流号
  // addExpress: (data) => apiAxios('post', baseURL + '/purchase.addExpress', data),
  // //客户付款后订单详情--删除物流号
  // deleteExpress: (data) => apiAxios('post', baseURL + '/purchase.deleteExpress', data),
  // //客户付款后订单详情--修改物流号
  // updateExpress: (data) => apiAxios('post', baseURL + '/purchase.updateExpress', data),
  // //客户付款后订单详情--交易号拆分
  // splitPurchaseNo: (data) => apiAxios('post', baseURL + '/purchase.splitPurchaseNo', data),
  // //客户付款后订单详情--交易号修改
  // updatePurchase: (data) => apiAxios('post', baseURL + '/purchase.updatePurchase', data),
  // //设置订单系统备注
  // updateSystemRemark: (data) => apiAxios('post', baseURL + '/order.updateSystemRemark', data),
  // // 采购-待采购列表
  // purchaseOrderList: (data) => apiAxios('post', baseURL + '/purchase.orderList', data),
  // // 采购-提交待付款
  // purchaseSubmit: (data) => apiAxios('post', baseURL + '/purchase.purchaseSubmit', data),
  // // 采购-待财务付款取消
  // purchaseCancel: (data) => apiAxios('post', baseURL + '/purchase.purchaseCancel', data),
  // // 采购-生成1688订单
  // alibabaOrderCreate: (data) => apiAxios('post', baseURL + '/purchase.alibabaOrderCreate', data),

  // 商品跟进-列表TAB统计
  sortingTrackingListTabNum: (data) => apiAxios('post', baseURL + '/follow.sortingTrackingListTabNum', data),
  // 商品跟进-列表
  sortingTrackingList: (data) => apiAxios('post', baseURL + '/follow.sortingTrackingList', data),
  // 商品跟进-修改业务跟进备注
  updateFollowYRemark: (data) => apiAxios('post', baseURL + '/follow.updateFollowYRemark', data),
  // 商品跟进-修改内部业务跟进备注
  updateFollowYRemarkInside: (data) => apiAxios('post', baseURL + '/follow.updateFollowYRemarkInside', data),
  // 商品跟进-修改业务跟进备注
  updateFollowGRemark: (data) => apiAxios('post', baseURL + '/follow.updateFollowGRemark', data),
  //商品跟进-修改配货跟进备注
  updateFollowPRemark: (data) => apiAxios('post', baseURL + '/follow.updateFollowPRemark', data),
  //订单-修改管理番号
  batchUpdateOrderDetailForSn: (data) => apiAxios('post', baseURL + '/order.batchUpdateOrderDetailForSn', data),
  // 商品跟进-修改内部业务跟进备注
  updateFollowYRemarkInside: (data) => apiAxios('post', baseURL + '/follow.updateFollowYRemarkInside', data),
  //订单-尝试补全订单信息
  reCompletion: (data) => apiAxios('post', baseURL + '/order.reCompletion', data),
  //订单-工厂直发订单修改计算绩效规则
  updateOrderPerformance: (data) => apiAxios('post', baseURL + '/order.updateOrderPerformance', data),

  //订单-大货单-option模板
  orderBulkOptionList: (data) => apiAxios('post', baseURL + '/order.bulkOrder.optionList', data),
  //订单-大货单-设置空运海运单价
  orderBulkUpdatePrice: (data) => apiAxios('post', baseURL + '/order.bulkOrder.updatePrice', data),
  //大货单-原价计算书数据
  bulkOrderPrice: (data, config) => apiAxios('post', baseURL + '/order.bulkOrder.bulkOrderPrice', data, config),
  //订单-大货单-保存
  bulkOrderSaveDetail: (data) => apiAxios('post', baseURL + '/admin/bulk/order/saveDetail', data),
  //订单-追加商品到订单
  appendToOrderBulk: (data) => apiAxios('post', baseURL + '/order.appendToOrderBulk', data),
  //唐吉-设置单番长度
  setExtendLength: (data) => apiAxios('post', baseURL + '/admin/bulk/order/setExtendLength', data),
  //唐吉-设置单番宽度
  setExtendWidth: (data) => apiAxios('post', baseURL + '/admin/bulk/order/setExtendWidth', data),
  //唐吉-设置单番高度
  setExtendHeight: (data) => apiAxios('post', baseURL + '/admin/bulk/order/setExtendHeight', data),
  //唐吉-设置单番重量
  setExtendWeight: (data) => apiAxios('post', baseURL + '/admin/bulk/order/setExtendWeight', data),
  //唐吉-设置单番图片
  setExtendImages: (data) => apiAxios('post', baseURL + '/admin/bulk/order/setExtendImages', data),

  // 采购询盘消息-客户-列表
  purchaseMessageClientList: (data) => apiAxios('post', baseURL + '/purchaseMessageClient.list', data),
  // 采购询盘消息-客户-添加消息
  purchaseMessageClientBatchAdd: (data) => apiAxios('post', baseURL + '/purchaseMessageClient.batchAdd', data),
  // 采购询盘消息-客户-更新消息
  purchaseMessageClientUpdate: (data) => apiAxios('post', baseURL + '/purchaseMessageClient.update', data),
  // 采购询盘消息-客户-批量删除
  purchaseMessageClientBatchDelete: (data) => apiAxios('post', baseURL + '/purchaseMessageClient.batchDelete', data),
  // 采购询盘消息-客户-批量查询客户
  purchaseMessageClientBatchQueryUsers: (data) => apiAxios('post', baseURL + '/purchaseMessageClient.batchQueryUsers', data),

  // 唐吉-打印标签
  bulkExcelResult: (data) => apiAxios('post', baseURL + '/admin/bulk/order/bulkExcelResult', data),

  // 1643-成本分析-后台查询订单纳期
  getDeliveryDays: (data) => apiAxios('post', baseURL + '/admin/cost-analysis/order/getDeliveryDays', data),
  // 1643-成本分析-后台保存订单纳期标题
  saveTitle: (data) => apiAxios('post', baseURL + '/admin/cost-analysis/order/saveTitle', data),
  // 1643-成本分析-后台保存订单纳期颜色
  saveColor: (data) => apiAxios('post', baseURL + '/admin/cost-analysis/order/saveColor', data),
  // 1643-成本分析-后台保存订单纳期尺寸
  saveSize: (data) => apiAxios('post', baseURL + '/admin/cost-analysis/order/saveSize', data),
  // 1643-成本分析-后台保存订单纳期
  saveDeliveryDays: (data) => apiAxios('post', baseURL + '/admin/cost-analysis/order/saveDeliveryDays', data),
}
